import { useQuery } from '@tanstack/react-query';
import { fetchWorkflowTypes } from '../../../api/Workflows.client';
import { queryKeys } from '../../../api/queryKeys';
import { NormalizedWorkflowType } from '../types';

const ALL_TYPES_OPTION: NormalizedWorkflowType = {
  description: '',
  label: 'All Types',
  response_header: '',
  value: '',
};

export function useWorkflowTypes() {
  const { data, isLoading, isError } = useQuery({
    gcTime: 8 * 60 * 60 * 1000,
    queryFn: fetchWorkflowTypes,
    queryKey: queryKeys.workflowTypes(),
    staleTime: Infinity,
  });

  const workflowTypes: NormalizedWorkflowType[] = [
    ALL_TYPES_OPTION,
    ...(data ?? []).map((wt) => ({
      description: wt.description_text,
      label: wt.workflow_desc,
      response_header: wt.response_header,
      value: wt.workflow_typ,
    })),
  ];

  return { isError, isLoading, workflowTypes };
}
